import { render, staticRenderFns } from "./user.vue?vue&type=template&id=5bfb8434&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&lang=css&"
import style1 from "./user.vue?vue&type=style&index=1&id=5bfb8434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb8434",
  null
  
)

export default component.exports